/* Mirrors base/models.py ORDER_STATUS_CHOICES/ORDER_STATUS_FLOW and
   admin/src/constants/orderStatus.js — kept in sync manually since the
   two SPAs are independent CRA projects with no shared package (see
   e.g. cartConstants.js existing separately in both already).
   Labels here are translation keys (see i18n/translations.js), not
   literal Hungarian text, since the customer app is multi-language. */
export const ORDER_STATUSES = [
  { key: "received", labelKey: "orderStatusReceived", emoji: "🟢" },
  { key: "preparing", labelKey: "orderStatusPreparing", emoji: "🟡" },
  { key: "ready", labelKey: "orderStatusReady", emoji: "🔵" },
  { key: "completed", labelKey: "orderStatusCompleted", emoji: "⚫" },
];

export const statusIndex = (key) => ORDER_STATUSES.findIndex((s) => s.key === key);
